// src/lib/queryClient.ts
import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client instance.
 *
 * Defaults per the frontend overhaul plan:
 *   staleTime: 30s       — data is fresh for 30s before background refetch
 *   retry: 1              — one retry on failure (Supabase blips are common)
 *   refetchOnWindowFocus: false — we use realtime invalidation instead
 *   refetchOnReconnect: true    — refetch when network reconnects
 *
 * Realtime events (centralized realtimeStore) call invalidateQueries()
 * to trigger targeted refetches — no polling needed.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});